
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[subdomain]/book/service-selection",
      function () {
        return require("private-next-pages/[subdomain]/book/service-selection/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[subdomain]/book/service-selection"])
      });
    }
  